import React from "react";

export default class MobileGameControls extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            styles: {
                
            }
        }

        this.repositionControls = () => {
            // console.log('repositionControls()')
            let canvas = document.querySelector('canvas')
            if (!canvas) return;
            let clientRect = canvas.getBoundingClientRect()
            // console.log(clientRect)
            let top = clientRect.bottom
            let styles = {...this.state.styles}
            styles.top = Math.round(top)
            this.setState({ styles })
        }
    }

    componentDidMount() {
        this.repositionControls()
        window.repositionControls = this.repositionControls

        setTimeout(() => {
            try {
                if (typeof window.repositionControls === 'function') {
                    window.repositionControls()
                }
            } catch(e) {
                console.warn(e)
            }
        }, 1000)
    }
    componentWillUnmount() {
        window.repositionControls = null
    }

    handleTouchStart = (key) => (e) => {
        // e.preventDefault()
        // e.stopPropagation()
        // console.log(key + ' Pressed!')
        window.mobileGameController.setKeyPressed(key, true)
        return false
    }
    handleTouchEnd = (key) => (e) => {
        // e.preventDefault()
        // e.stopPropagation()
        // console.log(key + ' Released!')
        window.mobileGameController.setKeyPressed(key, false)
        return false
    }    

    render() {
        return (
            <div style={{...this.state.styles, position: 'absolute', width: '100%'}} className="container-fluid mobile-controls mt-4">
                <div className="row">
                    <div className="col-4" >
                        <i onTouchEnd={this.handleTouchEnd('UP')} onTouchStart={this.handleTouchStart('UP')} className="fa-solid fa-circle-up"></i>
                    </div>
                    <div className="col-8 text-right" >
                        <i onTouchEnd={this.handleTouchEnd('LEFT')} onTouchStart={this.handleTouchStart('LEFT')} className="fa-solid fa-circle-left mr-4"></i>
                        <i onTouchEnd={this.handleTouchEnd('RIGHT')} onTouchStart={this.handleTouchStart('RIGHT')} className="fa-solid fa-circle-right"></i>
                    </div>
                </div>
            </div>
            
        )
    }
}